import { EledaMessagesFR } from "./EledaMessagesFR";
import { EledaMessagesEN } from "./EledaMessagesEN";
import { EledaMessagesIT } from "./EledaMessagesIT";
import { EledaMessagesDE } from "./EledaMessagesDE";
import { styleSettings } from "../../../src/config/settings-features.mjs";
import { setStyleToObject } from "../modules/utils/rendering/Utils-Html-Style.mjs";

const EledaMessagesLanguages = [
  { lang: "fr", EledaMessages: EledaMessagesFR },
  { lang: "en", EledaMessages: EledaMessagesEN },
  { lang: "it", EledaMessages: EledaMessagesIT },
  { lang: "de", EledaMessages: EledaMessagesDE },
];

const EledaMessagesColor = {
  defaultMessageSolutionFound: styleSettings.color.success,
  defaultMessageSolutionFoundAtFirstAttempt: styleSettings.color.success,
  defaultMessageSolutionNotFound: styleSettings.color.danger,
  defaultMessageSolutionNotFoundButRemainingAttempts:
    styleSettings.color.orange,
};

const EledaMessagesAlignment = {
  defaultMessageSolutionFound: "center",
  defaultMessageSolutionFoundAtFirstAttempt: "center",
  defaultMessageSolutionNotFound: "center",
  defaultMessageSolutionNotFoundButRemainingAttempts: "center",
};

const fallbackLanguage = "en";
export var currentLanguage = "en";
/**
 * If translation exists in EledaMessage choose the good one.
 * otherwise choose fallbackLanguage
 * @param {*} lang
 */
export function setEledaMessagesLanguage(lang) {
  if (EledaMessagesLanguages.map((item) => item.lang).includes(lang)) {
    currentLanguage = lang;
  } else {
    currentLanguage = fallbackLanguage;
  }
}

export var currentEledaFeedbackType = "neutral";

export function setEledaMessagesFeedbackType(type) {
  if (type == "neutral") {
    currentEledaFeedbackType = "neutral";
  } else if (type == "kids") {
    currentEledaFeedbackType = "kids";
  } else if (type == "formal") {
    currentEledaFeedbackType = "formal";
  }
}

export function getEledaDecimalSeparator() {
  // Utiliser Intl.NumberFormat pour obtenir le format de nombre pour la langue spécifiée
  const formatter = new Intl.NumberFormat(currentLanguage);

  // Formater un nombre avec une décimale pour obtenir le séparateur
  const parts = formatter.formatToParts(1.1);

  // Trouver la partie qui correspond au séparateur des décimales
  const decimalPart = parts.find((part) => part.type === "decimal");

  // Retourner le séparateur des décimales
  return decimalPart ? decimalPart.value : ".";
}

export function getEledaMessage(key) {
  console.log(
    "getEledaMessage",
    currentLanguage,
    currentEledaFeedbackType,
    key
  );
  try {
    console.log(
      EledaMessagesLanguages.filter(
        (eledaMessagesLang) => eledaMessagesLang.lang == currentLanguage
      )
    );
    if (
      EledaMessagesLanguages.filter(
        (eledaMessagesLang) => eledaMessagesLang.lang == currentLanguage
      )[0].EledaMessages[key][currentEledaFeedbackType]
    ) {
      var message = EledaMessagesLanguages.filter(
        (eledaMessagesLang) => eledaMessagesLang.lang == currentLanguage
      )[0].EledaMessages[key][currentEledaFeedbackType];
    } else {
      var message = EledaMessagesLanguages.filter(
        (eledaMessagesLang) => eledaMessagesLang.lang == currentLanguage
      )[0].EledaMessages[key];
    }

    //if return filtered object is Array get one randomly
    if (Array.isArray(message)) {
      message = message[Math.floor(Math.random() * message.length)];
    }
    //convert into real object to apply style if needed (to clone object)
    message = new String(message);
    //If a std color and alignment is defined apply styleObject
    if (EledaMessagesColor[key]) {
      setStyleToObject(message, {
        color: EledaMessagesColor[key],
      });
    }
    if (EledaMessagesAlignment[key]) {
      setStyleToObject(message, {
        alignment: EledaMessagesAlignment[key],
      });
    }
    console.log("message", message);
    return message;
  } catch (e) {
    return "Eleda Message doesn't exist. Key=" + key;
  }
}
